import DocViewer from "@cyntler/react-doc-viewer";
import { HeroProps } from "../HeroProps";
import { CommonHeroLayout } from "../layout/CommonHeroLayout";
import { useMemo } from "react";
import styled from "@emotion/styled";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

// set the doc-viewer's text color to black to avoid letting the KMS theme take control over it
// else the CSV content will show white on white when the KMS theme is set to dark
const StyledDocumentViewer = styled(DocViewer)`
    color: #000000;

    #pdf-download {
        display: none;
    }
`;

export interface DocumentViewerHeroProps extends HeroProps {
    ks: string;
}

/**
 * Document viewer component - renders a react-doc-viewer for document entries
 */
export function DocumentViewerHero(props: DocumentViewerHeroProps) {
    const { entry, ks } = props;

    // re-render only when entry.downloadUrl changes
    // resizing the screen causes re-fetching of the PDF url - avoid it unless the url actually changed
    const MemoizedDocViewer = useMemo(
        () => (
            <StyledDocumentViewer
                documents={[{ uri: entry.downloadUrl + "/ks/" + ks }]}
                config={{
                    header: {
                        disableHeader: true,
                        disableFileName: true,
                    },
                }}
            />
        ),
        [entry.downloadUrl, ks]
    );

    return <CommonHeroLayout collapsedHero={props.collapse}>{MemoizedDocViewer}</CommonHeroLayout>;
}

export default DocumentViewerHero;
